import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Session } from '../services/session';

@Injectable()
export class CompanyOperatingModeGuard {
  constructor(private router: Router, @Inject(Session) private session) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const data: any = route.data;
    const config = data.companyOperatingModeGuard;
    const mode = config.mode;
    const redirectTo = config.redirectTo || '';

    if (
      (mode === 'exempt' && this.session.areCompanyDriversExempt()) ||
      (mode === 'mixed' && this.session.areCompanyDriversMixed()) ||
      (mode === 'logs' && this.session.areCompanyDriversLogs())
    ) {
      this.router.navigate([redirectTo]);
      return false;
    } else {
      return true;
    }
  }
}
